import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store/store.ts";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from "@dr.pogodin/react-helmet";

// Build version from environment variable
window.APP_VERSION = process.env.REACT_APP_VERSION || Date.now().toString();

window.snapSaveState = () => ({
  __PRELOADED_STATE__: store.getState(),
});

const rootElement = document.getElementById("root");

const isReactSnap =
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

const app = (
  <Provider store={store}>
    {isReactSnap ? (
      <HelmetProvider>
        <App />
      </HelmetProvider>
    ) : (
      <PersistGate loading={null} persistor={persistor}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </PersistGate>
    )}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (rootElement) {
  rootElement.innerHTML = "";
  const root = createRoot(rootElement);
  root.render(app);
}

reportWebVitals();
